var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3OutdoorLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.33 43a5.42 5.42 0 005.41-5.41 5.35 5.35 0 00-1.67-3.89v-1.93a3.75 3.75 0 00-7.49 0v1.93a5.35 5.35 0 00-1.67 3.89A5.42 5.42 0 0051.33 43zm-1.75-7.73l.5-.37v-2.73h2.5v2.73l.5.38a2.888 2.888 0 011.17 2.32 2.92 2.92 0 11-5.83 0 2.89 2.89 0 011.17-2.33h-.01zm.5 10.23h2.5v5h-2.5v-5zm-8.88.5l3.19-3.19 1.77 1.77L43 47.72 41.2 46zm15.31-1.42l1.77-1.77L61.47 46l-1.77 1.72-3.19-3.14zm6.9-4.86h-4.16v-2.5h4.17l-.01 2.5zm-20 0h-4.16v-2.5h4.17l-.01 2.5zM69 59v4H7v-4h20V35.13L7 19.22v-5.11L31 33.2V59h38zM17 35v6h-6v-6h6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Outdoor_light.60c12328.svg";
export { SvgA3OutdoorLight as ReactComponent };